export default __webpack_public_path__ + "static/media/fauna-driver-usage.9eca30e0.png";